import type { RunnerId } from '@ps/isp-web-services-types';

import { initialState } from '..';
import type { BetSlipState } from '../types';

const selectionsRemoved = (state: BetSlipState, payload: RunnerId[]): BetSlipState => {
  if (state.isLocked) {
    return state;
  }

  const selectionsToRemain = state.selections.filter(
    (betSlipSelection) =>
      !payload.find(
        (payloadSelection) =>
          betSlipSelection.selectionId === payloadSelection.selectionId &&
          betSlipSelection.marketId === payloadSelection.marketId
      )
  );

  return {
    ...state,
    selections: selectionsToRemain,
    selectedPromotionPicker: initialState.selectedPromotionPicker,
    ...(selectionsToRemain.length === 0 && {
      acceptedOdds: initialState.acceptedOdds,
      opportunities: initialState.opportunities
    })
  };
};

export default selectionsRemoved;
